import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroBanner from './components/HeroBanner';
import FeaturesBanner from './components/FeaturesBanner';
import CategorySection from './components/CategorySection';
import HotRecommend from './components/HotRecommend';
import LatestUpdate from './components/LatestUpdate';
import AllContent from './components/AllContent';
import { siteInfo } from '@/mocks/movies';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <>
      <Navbar />
      <main>
        <HeroBanner />
        <FeaturesBanner />
        <CategorySection />
        <HotRecommend />
        <LatestUpdate />
        <AllContent />

        <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              加入我们的观影社区
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-lg mx-auto">
              丫丫影院每日更新海量影视资源，无需注册，随时随地免费观看高清电影电视剧。
            </p>
            <a
              href="/category/tv"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3.5 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer text-base"
            >
              <i className="ri-play-circle-fill text-xl"></i>
              开始免费观影
            </a>
          </div>
        </section>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'Organization',
              name: siteInfo.name,
              url: 'https://www.yayacinema.com/',
              description: siteInfo.description,
              email: siteInfo.email,
              logo: 'https://www.yayacinema.com/logo.png',
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'WebSite',
              name: siteInfo.name,
              url: 'https://www.yayacinema.com/',
              description: siteInfo.description,
              potentialAction: {
                '@type': 'SearchAction',
                target: 'https://www.yayacinema.com/search?q={search_term_string}',
                'query-input': 'required name=search_term_string',
              },
            }),
          }}
        />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}